module.exports = __webpack_public_path__ + "static/img/img(44).baf993d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(44).png
// module id = iTVb
// module chunks = 1